module.exports = __webpack_public_path__ + "img/amx-21.935f7cf6.jpg";